export const getSearchParam = (props: Object, paramName: string) => {
  const params = new URLSearchParams(props.location.search);
  return params.get(paramName);
};

export const getGenreParam = (location) => getSearchParam({ location }, 'genre') || '';

export const getClustersParam = (location) => getSearchParam({ location }, 'clusters') || '';
